import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/** Supplies the regimen display name for /catalog/:id while the layout breadcrumb renders. */
@Injectable({ providedIn: 'root' })
export class CatalogDetailBreadcrumbService {
    private readonly _label$ = new BehaviorSubject<string | null>(null);

    readonly label$ = this._label$.asObservable();

    setRegimenLabel(label: string | null): void {
        this._label$.next(label);
    }

    getRegimenLabel(): string | null {
        return this._label$.value;
    }
}
